import { GetReceiverById } from '@/api/ShowPhone';

const state = {
  GetReceiverById : {},
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  },
};
const actions = {
  GetReceiverById({ commit },data) { // 获取更换微信二维码
    return new Promise((resolve)=>{
      GetReceiverById(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'GetReceiverById',data:newData});
        } catch (error) {
          console.log(error)  
        }
        resolve( res.data )
      });
    })
  },
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
